import { ISettingsState } from "types/reducers";
import { RequestStatus } from "types/requests";
import { SettingsActionTypes, SettingsTypeKeys } from "actions/settings";

const initialState: ISettingsState = {
  requests: {
    enforcementRequestStatus: RequestStatus.NOT_STARTED,
    enforcementPostStatus: RequestStatus.NOT_STARTED,
  },
  enforcementOn: false,
  gracePeriod: 600,
};

export default function settings(
  state: ISettingsState = initialState,
  action: SettingsActionTypes
): ISettingsState {
  switch (action.type) {
    case SettingsTypeKeys.SET_ENFORCEMENT_SETTINGS_REQUEST_STATUS:
      return {
        ...state,
        requests: {
          ...state.requests,
          enforcementRequestStatus: action.enforcementRequestStatus,
        },
      };
    case SettingsTypeKeys.RECEIVE_ENFORCEMENT: {
      const {
        enforcementSettings: { enforcementOn, gracePeriod },
      } = action;
      return {
        ...state,
        enforcementOn,
        gracePeriod,
      };
    }
    case SettingsTypeKeys.SET_ENFORCEMENT_POST_STATUS:
      return {
        ...state,
        requests: {
          ...state.requests,
          enforcementPostStatus: action.enforcementPostStatus,
        },
      };
    case SettingsTypeKeys.UPDATE_ENFORCEMENT_SETTINGS: {
      const { enforcementOn, gracePeriod } = action;
      return {
        ...state,
        enforcementOn,
        gracePeriod,
      };
    }
    default: {
      return state;
    }
  }
}
